export const getMaybeRefValue = <T>(maybeRef: MaybeRef<T>): T =>
  isRef(maybeRef) ? maybeRef.value : maybeRef
